<template>
  <article class="BlogArticle">

    <header class="BlogArticle-header">

      <h2 class="BlogArticle-title t-heading-md">

        <component
          :is="route ? 'router-link': 'span'"
          :to="route">

          {{ post.attributes.title }}

        </component>

      </h2>

      <p class="BlogArticle-date t-text-sm"
        v-if="showDate">
        {{ date | formatDate('mmmm d, yyyy') }}
      </p>

    </header>

    <section class="BlogArticle-content">

      <markdown :content="post.body" />

    </section>

  </article>
</template>

<script>
export default {
  name: 'BlogArticle',

  props: {
    post: {
      type: Object,
      required: true
    },

    route: { // Pass in a route object to link to the single post
      type: Object
    },

    showDate: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    date () {
      return this.post.attributes.date
    }
  }
}
</script>

<style>
@import 'properties';

.BlogArticle-header {

  @media (min-width: 960px) {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }
}

.BlogArticle-title a {
  color: inherit;
}

.BlogArticle-title a:hover {
  color: var(--c-blue) !important;
}

.BlogArticle-date {
  margin-top: 0px;
}

.BlogArticle-content{
  margin-top: 15px;
}

/**
 * Pull content to full-width for smaller screens
 */
.BlogArticle-content .Markdown {
  margin: 0 calc(-1 * var(--unit));
  padding: 0 var(--unit);

  @media (min-width: 960px) {
    margin: 0;
    padding: 0;
  }
}

/**
 * Override image component styles to allow full-bleed
 */
.BlogArticle-content .Markdown-image {
  margin-right: calc(-1 * var(--unit));
  margin-left: calc(-1 * var(--unit));
  width: auto;

  @media (min-width: 960px) {
    margin-right: auto;
    margin-left: auto;
  }
}

.BlogArticle-content .Markdown p {
  @media (min-width: 960px) {
    max-width: 75%;
  }
}

.BlogArticle-content .ImageComponent {
  /* max-height: 100px !important; */
  /* max-width: 640px; */
  /* max-height: 640px; */
}
</style>



// WEBPACK FOOTER //
// BlogArticle.vue?dbdd32ea